import React, { useState, useEffect } from "react";
import axios from "../../libs/axios";
import { Formik, Form } from "formik";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import "../Assesment/assesment.css";
import { Button, CircularProgress, Autocomplete } from "@mui/material";
import { useLocation } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Cities = [
  "Adealide, SA",
  "Albury/ Wodonga, NSW/VIC",
  "Alice Springs, NT",
  "Armidale, NSW",
  "Auckland, NZ",
  "Brisbane, QLD",
  "Broome, WA",
  "Bunbury, WA",
  "Bundaberg, QLD",
  "Cairns, QLD",
  "Canberra, ACT",
  "Christchurch, NZ",
  "Darwin, NT",
  "Dubbo, NSW",
  "Dunedin, NZ",
  "Geelong, VIC",
  "Geraldton, WA",
  "Gladstone, WA",
  "Hamilton, NZ",
  "Hastings, NZ",
  "Hobart, TAS",
  "Kalgoorlie, WA",
  "Launceston, TAS",
  "Mackay, QLD",
  "Melbourne, VIC",
  "Mildura, VIC",
  "Mount Isa, QLD",
  "Napier, NZ",
  "Newcastle, NSW",
  "Perth, WA",
  "Port Hedland, WA",
  "Rockhampton, QLD",
  "Shepparton, VIC",
  "Sydney, NSW",
  "Townsville",
  "Tamworth, NSW",
  "Townsville, QLD",
  "Wagga Wagga, NSW",
  "Wellington, NZ",
  "Whyalla, SA",
  "Wollongong, NSW",
];

export default function NaturalHazardsExposure({
  formData,
  handlePreviousPage,
  previouscallingBackend,
  setPreviousCallingBackend,
  handleNextPage,
  callingBackend,
  setCallingBackend,
}) {
  const typeOptions = [
    { name: "Exposure", value: 0.7 },
    { name: "No Exposure", value: 1 },
  ];
  const typeOptionsTwo = [
    { name: "Exposure", value: 0.85 },
    { name: "No Exposure", value: 1 },
  ];

  const natural_hazard = [
    {
      id: 0,
      name: "Flood",
      label: "flood",
      type: { name: "", value: 1 },
      ri: 2,
      description: "",
    },
    {
      id: 1,
      name: "Surface Water",
      label: "surfaceWater",
      type: { name: "", value: 1 },
      ri: 3,
      description: "",
    },
    {
      id: 2,
      name: "Windstorm",
      label: "windstorm",
      type: { name: "", value: 1 },
      ri: 5,
      description: "",
    },
    {
      id: 3,
      name: "Cyclone",
      label: "cyclone",
      type: { name: "", value: 1 },
      ri: 6,
      description: "",
    },
    {
      id: 4,
      name: "Hail",
      label: "hail",
      type: { name: "", value: 1 },
      ri: 7,
      description: "",
    },
    {
      id: 5,
      name: "Bushfire",
      label: "bushfire",
      type: { name: "", value: 1 },
      ri: 8,
      description: "",
    },
    {
      id: 6,
      name: "Earthquake",
      label: "earthquake",
      type: { name: "", value: 1 },
      ri: 9,
      description: "",
    },
    {
      id: 7,
      name: "Other",
      label: "other",
      type: { name: "", value: 1 },
      ri: 1,
      description: "",
    },
  ];

  const toolbarOptions = [
    ["bold", "italic", "underline"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
  ];
  const module = { toolbar: toolbarOptions };

  const [ccity, setCity] = useState(
    formData?.natural_hazards_exposure?.city || ""
  );
  const [selectHazard, setSelectHazard] = useState([]);
  const [arr, setArr] = useState(
    formData?.natural_hazards_exposure?.n_h_exposure?.length
      ? [...formData.natural_hazards_exposure.n_h_exposure]
      : natural_hazard
  );

  const changeAutocompleteFormData = (value, name, id, selector) => {
    const datanew = selectHazard?.find(
      (i) => i.location?.trim().toLowerCase() === ccity?.trim().toLowerCase()
    );
    const objIndex = arr?.findIndex((obj) => obj?.id === id);
    arr[objIndex][name] = value || { name: "", value: 1 };

    if (!datanew) {
      console.warn(`No hazard data found for city: ${ccity}`);
      arr[objIndex]["description"] = "N/A";
    } else if (value?.name === "Exposure") {
      const hazardDescription = datanew[selector];
      arr[objIndex]["description"] = hazardDescription ?? "N/A";
    }

    setArr([...arr]);
  };

  const changeFormData = (value, name, id, selector) => {
    const datanew = selectHazard?.find((i) => i.location === ccity);
    const objIndex = arr?.findIndex((obj) => obj?.id === id);
    arr[objIndex][name] = value;
    if (value.name === "Exposure") {
      arr[objIndex]["description"] = datanew?.[selector] ?? "N/A";
    }
    setArr([...arr]);
  };

  const changeInputValues = (city) => {
    setCity(city);
    const inputsdata = selectHazard?.find((i) => i.location === city);

    const updateItem = (id, key) => {
      if (inputsdata?.[key] === undefined) {
        arr[id]["description"] = "N/A";
        arr[id]["type"] = { name: "No Exposure", value: 1 };
      } else {
        arr[id]["description"] = inputsdata[key];
        arr[id]["type"] = { name: "Exposure", value: id === 3 ? 0.85 : 0.7 };
      }
    };

    updateItem(2, "windstorm");
    updateItem(3, "cyclone");
    updateItem(4, "hail");
    updateItem(6, "earthquake");

    setArr([...arr]);
  };

  const { state } = useLocation();

  const submit = async () => {
    const availableScore = arr.reduce(
      (n, { type }) => n * Number(type?.value),
      1
    );
    try {
      setCallingBackend(true);
      await axios.put(`/assesment/natural_hazards_exposure/${state.id}`, {
        n_h_exposure: arr,
        city: ccity,
        available_score: Math.round(availableScore * 20),
      });
      handleNextPage();
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  const handleClick = () => {
    setPreviousCallingBackend(true);
    handlePreviousPage();
  };

  const getHazard = async () => {
    try {
      const { data } = await axios.get(`/hazardexposure/`);
      setSelectHazard(data);
    } catch (error) {
      console.error("Error fetching RI data:", error);
    }
  };

  useEffect(() => {
    getHazard();
  }, []);

  return (
    <div>
      <Formik
        initialValues={natural_hazard}
        onSubmit={submit}
        enableReinitialize
      >
        {({ dirty, isValid }) => (
          <Form>
            <Grid
              container
              xs={12}
              sx={{
                padding: "1rem",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p className="formName">PRS AREA - Natural Hazards Exposures</p>
              <Grid container xs={10} spacing={1}>
                <Grid item xs={12}>
                  <p className="font">City</p>
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    id="city"
                    name="city"
                    size="small"
                    sx={{ marginBottom: "5px" }}
                    value={ccity}
                    options={Cities}
                    getOptionLabel={(option) => option}
                    onChange={(event, newValue) => changeInputValues(newValue)}
                    renderInput={(params) => (
                      <TextField size="small" {...params} />
                    )}
                  />
                </Grid>

                {arr.map((item) => (
                  <Grid item xs={12} key={item.id} sx={{ marginTop: "1.5rem" }}>
                    <p className="font">{item.name}</p>
                    <Autocomplete
                      id={`type-${item.id}`}
                      name="type"
                      size="small"
                      sx={{ marginBottom: "5px" }}
                      value={item?.type}
                      options={
                        item.id === 0 ||
                        item.id === 3 ||
                        item.id === 5 ||
                        item.id === 6
                          ? typeOptions
                          : typeOptionsTwo
                      }
                      getOptionLabel={(option) => option.name}
                      onChange={(event, newValue) =>
                        changeAutocompleteFormData(
                          newValue,
                          "type",
                          item.id,
                          item.label
                        )
                      }
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                    />
                    <Grid item xs={12} sx={{ marginBottom: "50px" }}>
                      <ReactQuill
                        modules={module}
                        theme="snow"
                        value={item?.description}
                        style={{ marginBottom: "25px", height: "100px" }}
                        onChange={(e) =>
                          changeFormData(e, "description", item.id, item.label)
                        }
                      />
                    </Grid>
                  </Grid>
                ))}

                <Grid
                  container
                  item
                  xs={12}
                  sx={{ justifyContent: "space-between", marginTop: "2rem" }}
                >
                  <Button
                    variant="contained"
                    onClick={handleClick}
                    sx={{
                      backgroundColor: "#22345B",
                      textTransform: "capitalize",
                      fontFamily: "serif",
                      borderRadius: "8px",
                      ":hover": { backgroundColor: "#22345B" },
                    }}
                    disabled={previouscallingBackend}
                  >
                    {previouscallingBackend ? (
                      <CircularProgress
                        size={25}
                        sx={{ color: "#fff", margin: "0 5px" }}
                      />
                    ) : (
                      "Previous"
                    )}
                  </Button>

                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      backgroundColor: "#22345B",
                      textTransform: "capitalize",
                      fontFamily: "serif",
                      borderRadius: "8px",
                      ":hover": { backgroundColor: "#22345B" },
                    }}
                    disabled={
                      callingBackend ||
                      arr.some(
                        (item) =>
                          !item?.type?.name ||
                          (item.id !== 2 &&
                            item.id !== 3 &&
                            item.id !== 4 &&
                            item.id !== 6 &&
                            !item?.description)
                      )
                    }
                  >
                    {callingBackend ? (
                      <CircularProgress
                        size={25}
                        sx={{ color: "#fff", margin: "0 5px" }}
                      />
                    ) : (
                      "Next"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
}
